// import * as firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/auth'

if (!firebase.apps.length) {
  const config = {
    apiKey: process.env.apiKey,
    authDomain: process.env.authDomain,
    databaseURL: process.env.databaseURL,
    projectId: process.env.projectId,
    storageBucket: process.env.storageBucket,
    messagingSenderId: process.env.messagingSenderId,
    appId: process.env.appId,
    measurementId: process.env.measurementId,
  }
  firebase.initializeApp(config)
}

export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const facebookProvider = new firebase.auth.FacebookAuthProvider()
export const appleProvider = new firebase.auth.OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
// export const DB = firebase.database()
// export const StoreDB = firebase.firestore()
// export const functions = firebase.functions()
export default firebase
